import type React from 'react';
import { RowDrawerView } from './RowDrawerView';
import { useRowDrawer, type UseRowDrawerOptions } from './useRowDrawer';

type RowDrawerProps = UseRowDrawerOptions;

/**
 * The Products step's row drawer: one row of the file in a form, opened by
 * the row's press in the table or on a card (the address's `?row=`). Mounted
 * once by the step, inside its `CatalogImportProvider`; it renders nothing
 * until a row is opened. The exclusion handlers and the re-check are the
 * step's, so the drawer's Exclude / Include and Save behave as the table's.
 */
export const RowDrawer: React.FC<RowDrawerProps> = (props) => {
    const drawer = useRowDrawer(props);
    return <RowDrawerView {...drawer} />;
};
